import React, { type ReactElement } from 'react';

import Image from 'next/image';

import useTranslation from '@framework/hooks/useTranslation';

import appleStoreIcon from '@static/node/images/apple-store-icon.svg';
import googleStoreIcon from '@static/node/images/google-store-icon.svg';
import windowsStoreIcon from '@static/node/images/windows-store-icon.svg';

import NativeAppsLink from './NativeAppsLink/NativeAppsLink';

import styles from './NativeAppsLinks.module.scss';

const NativeAppsLinks = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <span className={styles.label}>{t('Download on')}</span>
            <ul className={styles.list}>
                <li className={styles.listItem}>
                    <NativeAppsLink link="https://itunes.apple.com/app/id1172873177">
                        <div className={styles.imageContainer}>
                            <Image src={appleStoreIcon} alt="Apple store" layout="fill" />
                        </div>
                    </NativeAppsLink>
                </li>
                <li className={styles.listItem}>
                    <NativeAppsLink link="https://play.google.com/store/apps/details?id=ch.sherpany.boardroom">
                        <div className={styles.imageContainer}>
                            <Image src={googleStoreIcon} alt="Google Play store" layout="fill" />
                        </div>
                    </NativeAppsLink>
                </li>
                <li className={styles.listItem}>
                    <NativeAppsLink link="https://www.microsoft.com/store/apps/9NH1PR95ZXF7">
                        <div className={styles.imageContainer}>
                            <Image src={windowsStoreIcon} alt="Windows store" layout="fill" />
                        </div>
                    </NativeAppsLink>
                </li>
            </ul>
        </div>
    );
};

export default NativeAppsLinks;
